import React from "react";

export default [
  {
    path: "/about",
    text: "About Us",
    icon: <i className="fa fa-heart" aria-hidden="true"></i>,
  },
  {
    path: "https://www.facebook.com/profile.php?id=61572176351387",
    text: "Facebook",
    direct: true,
    icon: <i className="fa fa-facebook" aria-hidden="true"></i>,
  },
  {
    path: "https://www.instagram.com/pedders_europe/",
    text: "Instagram",
    direct: true,
    icon: <i className="fa fa-instagram" aria-hidden="true"></i>,
  },
  {
    path: "/contact",
    text: "Contact us",
    icon: <i className="fa fa-phone" aria-hidden="true"></i>,
  },
];
